import { useEffect, useRef } from "react";
import RecapBloc from "../blocs/recap/RecapBloc";
import { isMobile, scroll2Top } from "../utils/utils";


export default function RecapPage() {
    
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        <h1 ref={pageGapRef} className="title mb-sm ml-lg-desktop">Récapitulatif</h1>
        <RecapBloc />
      </div>
    
    )

}